import { useState } from "react";
import { Button } from "@mui/material";
import { ModalProps, useModal, createUseModal } from "@imminently/react/context/modals";
import { useNotify } from "@imminently/react/store/notifications";
import Select from "react-select";

import PatientCardModal from "@/components/PatientCardModal";
import { PatientEncounter, Location } from "@/resources/types";
import { encounterService } from "@/services/encounter";
import { useSettingsContext } from "@/pages/settings/SettingsProvider";

const { useUpdate } = encounterService;

interface ChangePatientLocationModalProps {
  encounter: PatientEncounter;
}

const ChangePatientLocationModal = ({ props }: ModalProps<ChangePatientLocationModalProps>) => {
  const { popModal: close } = useModal();
  const { error } = useNotify();
  const { encounter } = props;
  const { location } = encounter;
  const { settings } = useSettingsContext();
  const locations = ((settings as any)?.locations ?? []) as Location[];

  const [value, setValue] = useState(location ?? null);
  const { mutateAsync } = useUpdate();

  const onChange = (newValue: any) => {
    setValue(newValue);
  };

  const onSubmit = async () => {
    try {
      const payload = { id: encounter.id, payload: { location: value?.id } as any };
      console.log("[Change location]", payload);
      await mutateAsync(payload);
      close();
    } catch (err) {
      console.error(err);
      error("Failed to change patient location");
    }
  };

  return (
    <PatientCardModal
      title="Change patient location"
      encounter={encounter}
      onClose={() => close()}
    >
      <Select
        value={value ? { value: value, label: value.name } : null}
        onChange={(option: any) => onChange(option?.value)}
        options={locations
          .filter(location => location.status === "active")
          .map(location => ({ value: location, label: location.name }))}
        placeholder="Select location..."
        isClearable
      />
      <Button sx={{ ml: "auto" }} color="success" onClick={onSubmit}>
        Set location
      </Button>
    </PatientCardModal>
  );
};

export const useChangePatientLocationModal = createUseModal(
  ChangePatientLocationModal
);
